/* eslint-disable react/require-default-props */
import * as React from "react";
import { FieldProps } from "formik";
import { cx } from "@emotion/css";
import formGroupStyles from "../css/formgroup.module.css";

interface OtherProps {
  label: string;
  options: string[];
  optionsLabel: string[];
  description: string;
  removeDefaultSelectOption: boolean;
  onChange?: React.ChangeEventHandler;
}

type FieldSelectProps = OtherProps & FieldProps;

const FieldSelect = ({
  field,
  form: { touched, errors, values, handleChange, setFieldValue },
  label,
  options,
  optionsLabel,
  description,
  removeDefaultSelectOption,
  onChange
}: FieldSelectProps): React.JSX.Element => {
  const fieldClasses = cx(
    formGroupStyles["form-group"],
    touched[field.name] && errors[field.name] ? formGroupStyles.error : ""
  );

  return (
    <div className={fieldClasses}>
      {label ? <label htmlFor={field.name}>{label}</label> : null}
      {/* Automatically fallback to plain text display if there is only one option */}
      {options.length === 1 ? (
        <p id={field.name} className={formGroupStyles.bold}>
          {field.value}
        </p>
      ) : (
        <div className={formGroupStyles["input-group"]}>
          <select
            style={{ width: "100%" }}
            {...field}
            id={field.name}
            onChange={e => {
              if (onChange) onChange(e);
              handleChange(e);
            }}
          >
            {!removeDefaultSelectOption && <option value="">Select</option>}
            {options.map((option, i) => (
              <option key={option} value={option}>
                {optionsLabel && optionsLabel[i]}
                {!optionsLabel && option}
              </option>
            ))}
          </select>
          {description ? (
            <span
              style={{
                marginLeft: "10px",
                fontSize: "14px",
                color: "#808080a1",
                fontStyle: "italic"
              }}
            >
              {description}
            </span>
          ) : null}
          <div className={formGroupStyles["error-messages"]}>
            {touched[field.name] && errors[field.name] && (
              <div id={`${field.name}ErrorMessage`}>
                {errors[field.name] as React.ReactNode}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FieldSelect;
